import {useAppSelector} from '../../../app/hooks/useAppSelector';
import {selectSession} from '../authSlice';

export const useIsAdmin = () => {
  const session = useAppSelector(selectSession);
  return session?.isAdmin === 'true';
};
